<!-- Common Dialog code here -->
<div class="dialog-container">
  <button
    *ngIf="data?.crossIcon"
    mat-icon-button
    aria-label=""
    mat-dialog-close
    (click)="modelClosed()"
  >
    <f-icon [iconConfig]="iconConfig"></f-icon>
  </button>

  <!-- Common Dialog title here -->
  <!-- To be used only when title is present in dialog popup. -->
  <!-- CCR6-1212 Below html is used to show Recording popup with heading. -->
 <h3 mat-dialog-title *ngIf="data?.title">{{ data?.title }}</h3>
 <h4 *ngIf="data?.subheading">{{data?.subheading}}</h4>

  <!-- Common Dialog message here -->
  <div mat-dialog-content><span class="timer-icon" *ngIf="timeoutMsg == data?.message"><i class="fa-light fa-timer"></i></span>{{ data?.message }}</div>
  <div class="timespan-text" *ngIf="timeoutMsg == data?.message">
    {{rootScope?.timespan}}</div>

  <!-- Common Dialog button here -->
  <div mat-dialog-actions>
    <div class="dialog-button-controls">
      <f-button
        *ngIf="data?.firstbutton"
        text="{{ data?.firstbutton }}"
        mat-dialog-close
        buttonTitle="{{ data?.firstbutton }}"
        (buttonClicked)="commonButton(data?.firstbutton)"
        type="button"
        variant="action"
      ></f-button>

      <f-button
        *ngIf="data?.secondbutton"
        text="{{ data?.secondbutton }}"
        mat-dialog-close
        buttonTitle="{{ data?.secondbutton }}"
        (buttonClicked)="commonButton(data?.secondbutton)"
        type="button"
        variant="progressive"
      ></f-button>
    </div>
  </div>
</div>
